import { Typography, TypographyProps } from '@mui/material'
import { FC } from 'react'

type TextCellProps = TypographyProps & {
  dataTestId?: string
}

/**
 * A reusable table cell component that renders text content with ellipsis overflow handling.
 * Extends MUI Typography component with custom styling for table cell presentation.
 */
export const TextCell: FC<TextCellProps> = ({ children, dataTestId, ...props }) => (
  <Typography
    {...(dataTestId ? { ['data-testid']: dataTestId } : {})}
    style={{
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
      ...props.style,
    }}
    {...props}
  >
    {children}
  </Typography>
)
